<!-- <template>
  <label class="toggle">
    <span v-if="labelBefore" class="toggle-label">{{ labelBefore }}</span>
    <input class="toggle-checkbox" type="checkbox" :checked="isChecked" @change="" />
    <div class="toggle-switch" />
    <span v-if="labelAfter" class="toggle-label">{{ labelAfter }}</span>
  </label>
</template> -->

<template>
  <label class="toggle">
    <span 
      class="toggle-label" 
      :class="{ 'toggle-active': currentValue === false }">
      <slot name="labelBefore" />
    </span>
    <input 
      class="toggle-checkbox"
      type="checkbox" 
      :id="id"
      :checked="value" 
      @change="$emit('change', $event.target.checked)" 
    />
    <div class="toggle-switch" />
    <span 
      class="toggle-label" 
      :class="{ 'toggle-active': currentValue === true}">
      <slot name="labelAfter" />
    </span>
  </label>
</template>

<script>
export default {
  props: {
    id: {
      type: String
    },
    value: {
      type: Boolean,
    },
  },
  computed: {
    currentValue() {
      return this.value
    }
  }
}
</script>

<style scoped>
  .toggle {
    cursor: pointer;
    display: inline-block;
  }

  .toggle-switch {
    display: inline-block;
    background: #ccc;
    border-radius: 16px;
    width: 58px;
    height: 32px;
    position: relative;
    vertical-align: middle;
    transition: background 0.25s;
  }
  .toggle-switch:before, .toggle-switch:after {
    content: "";
  }
  .toggle-switch:before {
    display: block;
    background: linear-gradient(to bottom, #fff 0%, #eee 100%);
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
    width: 24px;
    height: 24px;
    position: absolute;
    top: 4px;
    left: 4px;
    transition: left 0.25s;
  }
  .toggle:hover .toggle-switch:before {
    background: linear-gradient(to bottom, #fff 0%, #fff 100%);
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
  }
  .toggle-checkbox:checked + .toggle-switch {
    background: #56c080;
  }
  .toggle-checkbox:checked + .toggle-switch:before {
    left: 30px;
  }

  .toggle-checkbox {
    position: absolute;
    visibility: hidden;
  }

  .toggle-label {
    margin-left: 5px;
    position: relative;
    top: 2px;
    opacity: 0.1;
  }

  .toggle-active {
    opacity: 1;
  }
</style>